
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import ListProducts from './ListProducts';

function Index({dishs2, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [menus, setMenus] = useState([]);
    const [dataSignatureCocktails, setdataSignatureCocktails] = useState(false);
    const [dataTraditionalCocktails, setdataTraditionalCocktails] = useState(false);
    const [dataMocktails, setdataMocktails] = useState(false);
    const [dataMojitos, setdataMojitos] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 705) {
                setdataSignatureCocktails(item);
            }
            if (item.id === 707) {
                setdataTraditionalCocktails(item);
            }
            if (item.id === 708) {
                setdataMocktails(item);
            }
            if (item.id === 706) {
                setdataMojitos(item);
            }
        });
    }, [menus]);

    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    
                    
                    <img src={require('./assets/cevichebabber.jpg')} style={{
                        width: '80%',
                        height: 340, objectFit: 'cover', pointerEvents: 'none',
                        position: 'relative', zIndex: 1000,
                        borderRadius: 10,
                        marginTop: 50
                    }} />


                    <div
                                                onClick={() => {
                                                // setShowListProduct(true);
                                                // setdishs(dataSignatureCocktails);
                                                    
                                                }}
                                                style={{
                                                    width: '100%',
                                                
                                                   
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                  
                                                    display: 'flex',
                                                    marginTop: -100,
                                                    zIndex: 1,
                                                    
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                            position: 'relative',
                                                  
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/ceviche.png')} style={{
                                                            width: '100%',
                               // height: 450,
                                                      
                                pointerEvents: 'none',
                                                              marginTop: -55,
                                                    
                                                        }} />
                                                       
                                                </div>
                                            
                    </div>
                    <br/>
                    <br/>


                
                    

                </div>

                {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
                
                 {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;